import React from 'react';

import T from '@prisjakt/ui-translate';
import DataContainer from '../../../../components/data';
import Loader from '../../../../components/loader';
import CreateAlert from '../create-alert';
import productAlertFormQuery from './productAlertFormQuery.graphql';
import { ProductAlertFormData } from '../../types';

import * as S from './styles';
import ErrorMessage from '../../../../components/error-message';

interface ProductAlertModalContentProps {
  productId?: number;
  withoutGraph?: boolean;
  hideModal: () => void;
  privacyPolicyUri?: string;
}

interface RenderProps {
  data: ProductAlertFormData;
}

const ProductAlertModalContent = (props: ProductAlertModalContentProps) => {
  const { productId, withoutGraph, hideModal, privacyPolicyUri } = props;

  const renderError = () => <ErrorMessage />;

  const renderCallback = React.useCallback(
    ({ data }: RenderProps) => {
      const productAlertFormData = data;

      const isEdit = !!productAlertFormData?.product?.alert?.id;

      return (
        <S.Wrapper>
          <S.Title>
            {isEdit ? (
              <T domain="product">alert.title-edit</T>
            ) : (
              <T domain="product">alert.title</T>
            )}
          </S.Title>
          <div>
            <CreateAlert
              withoutGraph={withoutGraph}
              productAlertFormData={productAlertFormData}
              showCancel={false}
              onCreate={hideModal}
              privacyPolicyUri={privacyPolicyUri}
            />
          </div>
        </S.Wrapper>
      );
    },
    [hideModal, privacyPolicyUri, withoutGraph]
  );
  return (
    <DataContainer
      query={productAlertFormQuery}
      renderLoader={() => <Loader fadeIn />}
      variables={{ id: productId }}
      render={renderCallback}
      renderError={renderError}
    />
  );
};

export default ProductAlertModalContent;
